import { render } from "./CadastrarJogo.vue?vue&type=template&id=649b144b&scoped=true"
import script from "./CadastrarJogo.vue?vue&type=script&lang=js"
export * from "./CadastrarJogo.vue?vue&type=script&lang=js"

import "./CadastrarJogo.vue?vue&type=style&index=0&id=649b144b&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649b144b"]])

export default __exports__